import React from 'react'
import styled from 'styled-components'
import { useTotalSupply, useBurnedBalance } from 'hooks/useTokenBalance'
import { getCakeAddress } from 'utils/addressHelpers'
import { getBalanceNumber, formatLocalisedCompactNumber } from 'utils/formatBalance'
import { usePriceCakeBusd } from 'state/farms/hooks'
import { Flex, Text, Heading, Skeleton,LinkExternal } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import Balance from 'components/Balance'



const StyledColumn = styled(Flex)<{ noMobileBorder?: boolean }>`
  flex-direction: column;
  ${({ noMobileBorder, theme }) =>
    noMobileBorder
      ? `${theme.mediaQueries.md} {
           padding: 0 16px;
           border-left: 1px ${theme.colors.inputSecondary} solid;
         }
       `
      : `border-left: 1px ${theme.colors.inputSecondary} solid;
         padding: 0 8px;
         ${theme.mediaQueries.sm} {
           padding: 0 16px;
         }
       `}
`

const Grid = styled.div`
  display: grid;
  
  grid-gap: 16px 8px;
  margin-top: 24px;
  grid-template-columns: repeat(2, auto);

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-gap: 16px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-gap:10px;
    grid-template-columns: repeat(3, auto);
  }
`


const emissionsPerBlock = 17

const CakeDataRow = () => {
const { t } = useTranslation()
const imagePath = '/images/home/partners/'
const bannersrc1 = 'banner-1'
const bannersrc2 = 'banner-2'
const bannersrc3 = 'banner-3'
const bannersrc4 = 'banner-4'


return (
	  <StyledColumn className="owl-slider">
	 
		<StyledColumn className="slide-track owl-carousel owl-theme bannerslider">
		<StyledColumn className="slide item">
		<a href="/pools">
		<img src={`${imagePath}${bannersrc1}.png`} alt={t('banner-1')} />
		</a>
		</StyledColumn>
		
		<StyledColumn className="item">
		<a href="/farms">
		<img src={`${imagePath}${bannersrc3}.png`} alt={t('banner-3')} />
		</a>
		</StyledColumn>
	
		
		<StyledColumn className="item">
		<LinkExternal external href="https://perp.ampleswap.com/">
		<img src={`${imagePath}${bannersrc2}.png`} alt={t('banner-2')} />
		</LinkExternal>
		</StyledColumn>
		
		<StyledColumn className="item">
		<LinkExternal external href="https://t.me/amrendram">
		<img src={`${imagePath}${bannersrc4}.png`} alt={t('banner-4')} />
		
		</LinkExternal>
		</StyledColumn>
		
		
		</StyledColumn>
	  </StyledColumn>
	  
	  

	  
  )
}











 



export default CakeDataRow
